import React from 'react';
import { T } from '../../utils/theme';
import api from '../../services/api';
import { Phone, ArrowRight, Loader } from 'lucide-react';

const PhoneStep = ({ branchId, onFound, onNew }) => {
  const [phone, setPhone] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  const formatPhone = (value) => {
    const numbers = value.replace(/\D/g, '');
    if (numbers.length <= 10) {
      return numbers.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3').replace(/-$/, '');
    }
    return numbers.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3').replace(/-$/, '');
  };

  const lookup = async () => {
    if (!phone) return;
    setLoading(true);
    setError(null);
    try {
      // Valida se o número tem WhatsApp ativo. Se a barbearia não tiver instância
      // conectada, o backend responde { skipped: true } e seguimos normalmente.
      try {
        const v = await api.post('/kiosk/validate-phone', { phone, branchId });
        if (v && v.valid === false) {
          setError('Este número não tem WhatsApp. Informe um número com WhatsApp ativo para continuar.');
          setLoading(false);
          return;
        }
      } catch { /* fail-open: não bloquear por falha na validação */ }

      const res = await api.post('/kiosk/customers/lookup', { phone, branchId });
      onFound(res);
    } catch {
      onNew(phone);
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%', padding: '16px 18px', borderRadius: 16,
    background: T.fill, border: `1px solid ${T.separator}`,
    color: T.label, fontSize: 22, fontFamily: 'inherit',
    outline: 'none', letterSpacing: '0.02em', textAlign: 'center',
  };

  return (
    <div style={{
      minHeight: '100%', display: 'flex', flexDirection: 'column',
      background: T.bg,
    }}>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '40px 24px' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{
            width: 64, height: 64, borderRadius: 20, margin: '0 auto 20px',
            background: T.accentSoft, display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <Phone size={28} color={T.accent} />
          </div>
          <div style={{ fontSize: 28, fontWeight: 700, color: T.label, letterSpacing: '-0.025em' }}>Bem-vindo!</div>
          <div style={{ fontSize: 16, color: T.label2, marginTop: 6 }}>Informe seu telefone para continuar</div>
        </div>

        <div style={{
          background: '#fff', borderRadius: 20, padding: 24,
          boxShadow: '0 2px 16px rgba(0,0,0,0.06)',
        }}>
          <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: T.label2, marginBottom: 8 }}>Telefone</label>
          <input
            type="tel"
            placeholder="(00) 00000-0000"
            value={phone}
            onChange={(e) => { setPhone(formatPhone(e.target.value)); if (error) setError(null); }}
            onKeyDown={(e) => e.key === 'Enter' && !loading && phone && lookup()}
            disabled={loading}
            maxLength={15}
            style={inputStyle}
            autoFocus
          />
        </div>

        <button onClick={lookup} disabled={loading || !phone} style={{
          width: '100%', padding: 18, borderRadius: 16, border: 'none',
          background: (!phone || loading) ? T.fill2 : T.accent, color: '#fff',
          fontFamily: 'inherit', fontSize: 17, fontWeight: 600, cursor: (!phone || loading) ? 'not-allowed' : 'pointer',
          marginTop: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
          boxShadow: (!phone || loading) ? 'none' : '0 4px 14px rgba(10,132,255,0.35)',
        }}>
          {loading
            ? <><Loader size={18} className="animate-spin" /> Buscando...</>
            : <><span>Continuar</span><ArrowRight size={18} /></>}
        </button>

        {error && (
          <div style={{
            marginTop: 16, background: 'rgba(255,59,48,0.1)',
            border: '1px solid rgba(255,59,48,0.2)', borderRadius: 14,
            padding: '14px 16px', fontSize: 14, color: T.danger, textAlign: 'center',
          }}>
            {error}
          </div>
        )}
      </div>

      <div style={{ textAlign: 'center', padding: '16px 0 24px', fontSize: 12, color: T.label3 }}>Feito por Barbx</div>
    </div>
  );
};

export default PhoneStep;
